import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CashCountState, CashCountDetailDTO } from "../../../types/cash/cashCount";

const initialState: CashCountState = {

    auditStarted: false,

    countId: null,

    countNumber: null,

    expectedAmount: 0,

    countedAmount: 0,

    difference: 0,

    details: [],

    observations: "",

    loading: false

};

const cashCountSlice = createSlice({

    name: "cashCount",

    initialState,

    reducers: {

        /**
         * ▶️ Iniciar auditoría
         */
        startAudit(
            state,
            action: PayloadAction<{
                id: number
                countNumber: string
                expectedAmount: number
            }>
        ) {

            state.auditStarted = true

            state.countId = action.payload.id

            state.countNumber = action.payload.countNumber

            state.expectedAmount = action.payload.expectedAmount

        },

        /**
         * ⛔ Finalizar auditoría
         */
        finishAudit(state) {

            state.auditStarted = false;

            state.countId = null;

            state.countNumber = null;

            state.expectedAmount = 0;

            state.countedAmount = 0;

            state.difference = 0;

            state.details = [];

            state.observations = "";

        },

        /**
         * 🧾 Actualizar denominaciones
         */
        setDetails(state, action: PayloadAction<CashCountDetailDTO[]>) {

            state.details = action.payload;

        },

        /**
         * 🧮 Actualizar resultado
         */
        updateResult(state, action: PayloadAction<{ countedAmount: number, difference: number }>) {

            state.countedAmount = action.payload.countedAmount;

            state.difference = action.payload.difference;

        },

        /**
         * ✏️ Observaciones
         */
        setObservations(state, action: PayloadAction<string>) {

            state.observations = action.payload;

        },

        /**
         * ⏳ Loading
         */
        setLoading(state, action: PayloadAction<boolean>) {

            state.loading = action.payload;

        }

    }

});

export const {

    startAudit,
    finishAudit,
    setDetails,
    updateResult,
    setObservations,
    setLoading

} = cashCountSlice.actions;

export default cashCountSlice.reducer;